module.exports = __webpack_public_path__ + "img/icon_series.be21944e.png";